import { styled, TextField } from "@mui/material";

export const StyledTextField = styled(TextField)(({ theme, size, error }) => ({
  "& .MuiInputBase-root": {
    backgroundColor: "#fff",
    borderRadius: "4px",
    width: size === "xtraSmall" ? "200px" : undefined,
    height: size === "xtraSmall" ? "43px" : undefined,
    "@media (min-width: 320px) and (max-width: 400px)": {
      width: size === "xtraSmall" ? "160px" : undefined,
    },
    padding:
      size === "large"
        ? "30px 10px"
        : size === "medium"
        ? "10px 12px"
        : size === "semiMedium"
        ? "6px 12px"
        : "10px 10px",
    "& input": {
      fontWeight: 400,
      color: "rgb(68, 68, 69)",
      height: "20px !important",
      border: "none",
      outline: "none",
    },
    "& fieldset": {
      padding: 10,
      borderRadius: "5px",
      border: error ? "1px solid #F44336" : "1px solid rgba(181, 188, 188, 0.47) !important",
    },
    "&:hover fieldset": {
      border: error ? "1px solid #F44336" : "1px solid #179b9b",
    },
    "&.Mui-focused fieldset": {
      border: error ? "1px solid #F44336" : "1px solid #179b9b",
    },
  },
  "& label": {
    fontSize: size === "large" ? theme.typography.pxToRem(16) : "14px",
    lineHeight: "1.6rem",
    letterSpacing: "0.02rem",
    color: "rgb(98, 102, 102)",
  },
  "& label.Mui-focused": {
    color: "#333",
  },
  "&:hover label": {
    color: "#179b9b", 
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: error ? "#F44336" : "#ccc",
  },
  "& .MuiOutlinedInput-notchedOutline.Mui-focused": {
    borderColor: error ? "#F44336" : "#333",
  },
  "& .MuiOutlinedInput-notchedOutline.Mui-disabled": {
    borderColor: "#ccc",
  },
  "&.Mui-error": {
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#F44336",
    },
    "& label": {
      color: "#F44336",
    },
  },
  "&.Mui-disabled": {
    "& input": {
      backgroundColor: "#F5F5F5",
      color: "#A0A0A0",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#ccc",
    },
  },
}));

export const styles = {
    title: {
      fontSize: "24px",
      marginTop: "30px",
      marginBottom: "30px",
      color: "#3E4954",
      fontWeight: "bold",
    },
    titles: {
      fontSize: "24px",
      marginTop: "10px",
      marginBottom: "30px",
      color: "#3E4954",
      fontWeight: "bold",
    },
    image: {
      borderRadius: "4px",
      marginRight: "10px",
    },
    photoHeading: {
      color: "grey",
      marginLeft: "5px",
    },
    photoContent: {
      fontSize: "12.8px",
      pointerEvents: "none",
      border: "none",
      maxWidth: "100%",
      overflow: "hidden",
      whiteSpace: "normal",
      textAlign: "center",
      textOverflow: "ellipsis",
      display: "inline-block",
      direction: "ltr",
      boxShadow: "none",
      wordBreak: "break-word",
      "@media (min-width: 1200px) and (max-width: 1300px)": {
        marginLeft: "20px",
      },
    },
    note: {
      marginTop: "10px",
      fontSize: "12px",
      maxWidth: "100%",
      pointerEvents: "none",
      border: "none",
      maxWidth: "350px",
      overflow: "hidden",
      whiteSpace: "nowrap",
      textAlign: "center",
      textOverflow: "ellipsis",
      display: "inline-block",
      direction: "ltr",
      boxShadow: "none",
      "@media (min-width: 310px) and (max-width: 350px)": {
        fontSize: "10.8px",
      },
    },
  
    fileBoxContainer: {
      marginTop: "100px",
    },
    fileButtonContainer: {
      display: "flex",
      justifyContent: "space-around",
      padding: 2,
      gap: 0.6,
      fontSize: "16px",
    },
  
    saveButtonContainer: {
      display: "flex",
      justifyContent: "flex-end",
      fontSize: "16px",
      "@media (min-width: 320px) and (max-width: 400px)": {
        justifyContent: "center",
      },
    },
    textFieldContainer: {
      mt: 3,
      mb: 1,
      color: "#788088",
    },
    salesTextFieldContainer: {
      mt: 3,
      mb: 1,
      color: "#000",
    },
    submitGap: {
      mt: 4,
      mb: 3,
    },
    submitLoading: {
      color: "white",
      backgroundColor: "#06214b",
    },
    reactScroll: {
      height: "80vh",
    },
    reactScrollStyle: {
      width: "100%",
      height: "auto",
    },
    capacityWarning: { color: "#f5970ae5", fontWeight: "bold" },
    imageUploadClosePosition: { position: "relative", display: "inline-block" },
    imageUploadCloseContain: { borderRadius: "8px", objectFit: "cover" },
    imageUploadClose: {
      position: "absolute",
      top: 0,
      right: 0,
      background: "red",
      color: "white",
      border: "none",
      borderRadius: "30%",
      width: "15px",
      height: "15px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
    },
    addBackButtonDisplay: {
      display: "flex",
      justifyContent: "flex-end",
      width: "100%",
      marginTop: "12px"
    },
    addBackButtonColor: {
      backgroundColor: "#4c67ee",
      color: "#fff",
      marginTop: "20px",
    },
  };